// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY in client/.env');
}

// Create a single client instance
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

const PROFILE_BUCKET = 'id-profile';
const PUBLIC_URL_PREFIX = `/storage/v1/object/public/${PROFILE_BUCKET}/`;

// profile_url historically stored a full public URL; newer rows store just the
// storage object path. Accept either so old rows keep working without a migration.
export function extractProfileStoragePath(value) {
  if (!value) return null;
  if (!value.startsWith('http')) return value;
  try {
    return decodeURIComponent(new URL(value).pathname.replace(PUBLIC_URL_PREFIX, ''));
  } catch {
    return null;
  }
}

// The id-profile bucket is private, so photos are only viewable through a
// short-lived signed URL rather than a permanent public link.
export async function getSignedProfileUrl(value, expiresIn = 3600) {
  const path = extractProfileStoragePath(value);
  if (!path) return null;

  const { data, error } = await supabase.storage
    .from(PROFILE_BUCKET)
    .createSignedUrl(path, expiresIn);

  if (error) {
    console.error('Failed to create signed profile URL:', error);
    return null;
  }

  return data.signedUrl;
}
